import { memo, useCallback, useEffect, useState } from "react";
import {
    GelParagraph,
    GelCollapsible,
    GelContainerLite,
    GelBoxLayout,
    GelLabel,
    GelIcon,
    GelRowLayout,
    GelLink
} from '@tal-gel/components';
import { FormatHelper } from "../../../common/formatHelper.common";
import { useLocation, useNavigate } from "react-router-dom";
import { AdobeClickType, NotificationItemIds } from "../../../constants/constants";
import { getGelTokens } from '@tal-gel/theming';
import { useCookies } from "react-cookie";
import { AdobeAnalytics } from "../../../common/analytics/adobe-analytics";
import { useGetClaimDetailsContent } from "../../../common/api/graphQLDataFetch";
import { activeUploadActions, useActiveUploadStore } from "../documentsupload/activeUploadStore";

interface NextFuturePaymentProps {
    futurePayment: {
        friendlyText: string;
        description: string;
    } | undefined;
}

const NextFuturePayment = (props: NextFuturePaymentProps) => {
    const { global: { sizeBaseUnit, themeColorBorderDefault, themeColorIconDefault } } = getGelTokens()

    const navigate = useNavigate();
    const location = useLocation();
    const [{ tpid }] = useCookies(['tpid']);
    const { data } = useGetClaimDetailsContent()

    const activeId = useActiveUploadStore(s => s.activeRequirementId);    
    const isOpen = activeId === NotificationItemIds.FuturePayment;

    const onHeaderClick = useCallback(() => {
        const opening = !isOpen;
        activeUploadActions.setActiveRequirement(opening ? (NotificationItemIds.FuturePayment ?? null) : null);

        activeUploadActions.consumeUploadComplete();

        AdobeAnalytics.PushClickEvent(tpid, data?.nextPayment?.NextFuturePaymentHeader!, AdobeClickType.Button)
    }, [isOpen]);

    return (
        <div id={NotificationItemIds.FuturePayment}>
            <GelContainerLite style={{
                borderTop: `${sizeBaseUnit / 4}px solid ${themeColorBorderDefault}`,
                borderLeft: `${sizeBaseUnit / 4}px solid ${themeColorBorderDefault}`,
                borderRight: `${sizeBaseUnit / 4}px solid ${themeColorBorderDefault}`,
                paddingTop: sizeBaseUnit,
                paddingBottom: sizeBaseUnit,
                width: "auto",
                cursor: "pointer"
            }}
                onClick={onHeaderClick}>

                <GelBoxLayout space={[7, 0.1, 0.04]} style={{
                    borderBottom: isOpen ? `${sizeBaseUnit / 4}px solid ${themeColorBorderDefault}` : "",
                    width: "auto",
                    padding: sizeBaseUnit * 2,
                    marginLeft: -sizeBaseUnit * 4,
                    marginRight: -sizeBaseUnit * 4,
                }}>
                    <GelLabel large>
                        {data?.nextPayment.NextFuturePaymentHeader}
                    </GelLabel>

                    <GelIcon name={isOpen ? "ChevronUp" : "ChevronDown"} color={themeColorIconDefault} width="20px" height="20px"></GelIcon>
                </GelBoxLayout>
            </GelContainerLite>

            <GelContainerLite style={{
                borderBottom: `${sizeBaseUnit / 4}px solid ${themeColorBorderDefault}`,
                borderLeft: `${sizeBaseUnit / 4}px solid ${themeColorBorderDefault}`,
                borderRight: `${sizeBaseUnit / 4}px solid ${themeColorBorderDefault}`,
                width: "auto"
            }}>

                <GelCollapsible open={isOpen}>
                    <GelContainerLite style={{ padding: sizeBaseUnit * 4 }}>
                        <GelRowLayout>
                            <GelParagraph>
                                {FormatHelper.stringFormat(data?.nextFuturePaymentBody!,
                                    props.futurePayment?.friendlyText, props.futurePayment?.description)}
                            </GelParagraph>
                        </GelRowLayout>
                        <GelRowLayout style={{ paddingTop: sizeBaseUnit * 6 }} >
                                <GelLink onClick={() => navigate(`/payments`)}>View payment schedule</GelLink>
                        </GelRowLayout>
                    </GelContainerLite>
                </GelCollapsible>

            </GelContainerLite>
        </div>
    )
};

export default memo(NextFuturePayment);